<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="top-list-toolbar">
          <div>
            <h4 class="text-primary">Warehouse</h4>
            <ol class="breadcrumb breadcrumb-card-header">
              <li class="breadcrumb-item">
                <a href="javascript:void(0);" @click="backParent">Warehouse</a>
              </li>
              <li class="breadcrumb-item active">
                <span v-if="warehouse.id === null">New</span>
                <span v-else>
                  {{ warehouse.warehouse_no }}
                </span>
              </li>
            </ol>
            <button type="button" @click="backParent" class="btn btn-sm btn-danger pull-left"><i class="fa fa-reply" aria-hidden="true"></i> Back</button>
            <button type="button" @click="updateWarehouse" class="btn btn-sm btn-soft-primary pull-left" v-show="warehouse.id !== null"><i class="fa fa-check" aria-hidden="true"></i> Update</button>
            <button type="button" @click="createWarehouse" class="btn btn-sm btn-soft-primary pull-left" v-show="warehouse.id == null"><i class="fa fa-check" aria-hidden="true"></i> Create</button>
          </div>
        </div>
      </div>
    </div>
    <div class="card card-list">
      <div class="card-header">
        <div class="col-md-12">
            <h5 class="text-primary">
              <span v-if="warehouse.id === null">New</span>
              <span v-else>{{ warehouse.warehouse_no }}</span>
              <span class="ml-1">- {{ warehouse.name }}</span>
            </h5>
          </div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group row">
              <label for="warehouse_no" class="col-sm-3 col-form-label text-left">Warehouse Number</label>
              <div class="col-sm-9">
                <input type="text" v-model="warehouse.warehouse_no" class="form-control"/>
              </div>
            </div>
            <div class="form-group row">
              <label for="name" class="col-sm-3 col-form-label text-left">Name</label>
              <div class="col-sm-9">
                <input type="text" v-model="warehouse.name" class="form-control"/>
              </div>
            </div>
            <div class="form-group row">
              <label for="address" class="col-sm-3 col-form-label text-left">Address</label>
              <div class="col-sm-9">
                <textarea rows="5" v-model="warehouse.address" class="form-control"></textarea>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group row">
              <label for="phone" class="col-sm-3 col-form-label text-left">Phone</label>
              <div class="col-sm-9">
                <input type="text" v-model="warehouse.phone" class="form-control"/>
              </div>
            </div>
            <div class="form-group row">
              <label for="company_no" class="col-sm-3 col-form-label text-left">Company</label>
              <div class="col-sm-9">
                <select v-model="warehouse.company_no" class="form-control">
                  <option v-for="c in companyList" :key="c.company_no" :value="c.company_no">[{{ c.company_no }}] {{ c.name }}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer">
      </div>
    </div>
    <!-- <pre>
      {{ warehouse }}
    </pre> -->
  </div>
</template>
<script>
import axios from 'axios'
import { mapState } from 'vuex'
import { warehouseUrl, getHeader } from '../../config'

export default {
  name: 'WarehouseForm',
  props: ['warehouse'],
  computed: {
    ...mapState({
      branchList: state => state.branches.branchList,
      companyList: state => state.companies.companyList
    })
  },
  methods: {
    backParent: function () {
      this.$emit('backClicked')
    },
    updateWarehouse (response, message) {
      axios.put(warehouseUrl + '/' + this.warehouse.id, this.warehouse, { headers: getHeader() })
        .then(response => {
          this.$swal('Warehouse', response.data.message, 'success')
          this.$emit('backClicked')
        })
        .catch(error => {
          console.log(error.response)
          this.$swal('Error!!', response.data, 'error')
        })
    },
    createWarehouse (response, message) {
      axios.post(warehouseUrl, this.warehouse, { headers: getHeader() })
        .then(response => {
          this.$emit('backClicked')
        })
        .catch(error => {
          console.log(error.response)
          this.$swal('Error!!', error.response.data, 'error')
        })
    }
  }
}
</script>
